import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Prop, Mixins } from "vue-property-decorator";
import simplebar from "simplebar-vue";
import BaseMixer from "@/router/views/BaseMixer";
import { PACycleSaveModel } from "@/store/models/cycle/paCycleSaveDTO";
import TeamOverviewComponents from "./TeamOverview.vue";
let SelectResourceComponent = /** @class */ (() => {
    var _a;
    let SelectResourceComponent = class SelectResourceComponent extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.selectedTeam = {};
            this.hoveredTeam = {};
        }
        selectTeam(team) {
            this.selectedTeam = team;
            this.paCycleSave.pmoTeamId = team.id;
        }
        teamHoverView(team) {
            this.hoveredTeam = team;
        }
        created() {
            this.selectedTeam.id = this.paCycleSave.pmoTeamId;
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], SelectResourceComponent.prototype, "cycleTitlePeriod", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Array)
    ], SelectResourceComponent.prototype, "teamList", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_a = typeof PACycleSaveModel !== "undefined" && PACycleSaveModel) === "function" ? _a : Object)
    ], SelectResourceComponent.prototype, "paCycleSave", void 0);
    SelectResourceComponent = __decorate([
        Component({
            name: "SelectResourceComponent",
            components: {
                simplebar,
                TeamOverviewComponents,
            },
        })
    ], SelectResourceComponent);
    return SelectResourceComponent;
})();
export default SelectResourceComponent;
